import { render, staticRenderFns } from "./studentAccount.vue?vue&type=template&id=1827a24a&scoped=true"
import script from "./studentAccount.vue?vue&type=script&lang=js"
export * from "./studentAccount.vue?vue&type=script&lang=js"
import style0 from "./studentAccount.vue?vue&type=style&index=0&id=1827a24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1827a24a",
  null
  
)

export default component.exports